/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "../../../app/bsky/actor/defs.defs.js";

const $nsid = "place.stream.moderation.defs";

export { $nsid };

type PermissionView = { $type?: "place.stream.moderation.defs#permissionView";

  /**
   * AT-URI of the permission record
   */
  "uri":l.AtUriString;

  /**
   * Content identifier of the permission record
   */
  "cid":l.CidString;

  /**
   * The streamer who granted these permissions
   */
  "author":ActorDefs.ProfileViewBasic;

  /**
   * The permission record itself
   */
  "record":l.LexMap };

export type { PermissionView };

const permissionView = /*#__PURE__*/ l.typedObject<PermissionView>($nsid, "permissionView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.lexMap()}));

export { permissionView };
